module.exports = __webpack_public_path__ + "static/media/BG03.7ad92d7a.png";